import(/* webpackMode: "eager" */ "/var/www/InfinityV1/app/expedition/[distance]/page.tsx");
